module.exports = __webpack_public_path__ + "static/img/process-white-point.0e8eff79.png";